import { LitElement, TemplateResult, html } from 'lit';
import { AdoptedStyleSheets } from '../../controllers/adopted-stylesheets';
import { customElement, property } from 'lit/decorators.js';
import innerStyles from './styles/outline-logo.base.pcss?inline';
import globalStyles from './styles/outline-logo.global.pcss?inline';
import '../outline-svg/outline-svg';

export const logoThemes = ['light', 'dark'] as const;
export type LogoTheme = (typeof logoThemes)[number];

export const logos = ['bjc', 'stLukes'] as const;
export type Logo = (typeof logos)[number];

/**
 * The OutlineLogo component
 * @element outline-logo
 */
@customElement('outline-logo')
export class OutlineLogo extends LitElement {
  adoptedStyleSheets = new AdoptedStyleSheets(this, {
    globalCSS: globalStyles,
    encapsulatedCSS: innerStyles,
  });

  /**
   * True if the logo should me wrapped in an anchor tag returning to the home page.
   */
  @property({ type: Boolean, attribute: 'home-link' })
  homeLink: boolean;

  /**
   * Sets the fill color based on the background hue.
   */
  @property({ type: String })
  theme: LogoTheme;

  /**
   * Sets which organization's logo to use.
   */
  @property({ type: String })
  logo: Logo = 'bjc';

  /**
   * The width of the logo.
   */
  @property({ attribute: 'size' })
  size: string | boolean = false;

  /**
   * The width of the logo.
   */
  @property({ attribute: 'home-url' })
  homeUrl = '/';

  render(): TemplateResult {
    return html` <div class="outline-logo">${this.contentTemplate()}</div> `;
  }

  logoSvgTemplate() {
    return html`
      <outline-svg
        name=${this.logo}
        size=${this.size}
        svg-fill=${this.theme === 'light'
          ? `var(--background-brand-primary-bold)`
          : `var(--background-neutral-subtlest)`}
        theme=${this.theme}
      >
      </outline-svg>
    `;
  }

  contentTemplate() {
    if (this.homeLink) {
      return html`
        <a href="${this.homeUrl}" aria-label="Go to homepage">
          ${this.logoSvgTemplate()}
        </a>
      `;
    } else {
      return this.logoSvgTemplate();
    }
  }
}
